import React from 'react';
import { useRecoilState } from 'recoil';

import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifButton,
  MotifIcon,
} from '@ey-xd/motif-react';

import { HeaderWrapper, ParagraphStyle } from '@organisms/modals/styles/modalStyles';

import { Message_Modal_State } from '@recoil/recoil';

const MessageModal = () => {
  const [messageModal, setMessageModal] = useRecoilState(Message_Modal_State);

  if (!messageModal.isOpen) return null;

  const Header = ({ children }) => <HeaderWrapper>{children}</HeaderWrapper>;

  const handleClose = () => {
    setMessageModal(prev => ({ ...prev, isOpen: false }));
  };

  return (
    <MotifModal
      variant="alt"
      show={messageModal.isOpen}
      onClose={handleClose}
      style={{ width: '485px' }}
      className={messageModal.className}
      focusTrapOptions={{ initialFocus: false }}
    >
      <MotifModalHeader closeModalButton={true}>
        <Header>
          <MotifIcon
            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJzNC40OCAxMCAxMCAxMCAxMC00LjQ4IDEwLTEwUzE3LjUyIDIgMTIgMnptMSAxNWgtMnYtMmgydjJ6bTAtNGgtMlY3aDJ2NnoiLz48L3N2Zz4="
            style={{ color: '#F95D54', lineHeight: 1, paddingRight: '8px' }}
          />
          {messageModal.headerTitle}
        </Header>
      </MotifModalHeader>

      <MotifModalBody>
        <ParagraphStyle>{messageModal.bodyContent}</ParagraphStyle>
      </MotifModalBody>

      <MotifModalFooter>
        <MotifButton variant="secondary" onClick={handleClose}>
          {messageModal.closeButtonText}
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  );
};

export default MessageModal;
